export const convertLocationFromUrl = (url) => {
  if (url !== null && url !== undefined && url !== '') {
    const urlValues = url.split(',');
    const urlNumbervalues = urlValues.map(elem => {
      return Number(elem);
    });
    return urlNumbervalues;
  }
};
